import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
`;

export const SubTitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
`;

export const DataTitle = styled.h3`
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
`;

export const Datasets = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    margin-bottom: 1.5em;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    .datasetName .checksum {
        color: #1565c0;
    }
`;
